/* eslint-disable @typescript-eslint/no-explicit-any */
import { useCallback, useEffect } from "react";

function useClosePopUp(
  isDropdownVisible: boolean,
  inputRef: any,
  clickCallback: (param?: any) => void
) {
  const handleClickOutside = useCallback((e: MouseEvent) => {
    if (inputRef) {
        if (inputRef?.current && !inputRef?.current.contains(e.target as Node)) {
          clickCallback(false);
        }
    }
  }, [inputRef, clickCallback]);

  useEffect(() => {
    if (isDropdownVisible) {
      document.addEventListener("click", handleClickOutside);

      return () => {
        document.removeEventListener("click", handleClickOutside);
      };
    }

    return undefined;
  }, [isDropdownVisible, handleClickOutside]);

  return handleClickOutside;
}

export default useClosePopUp;
